import vueInstance from "../main"
import { isString } from "@/util/utils"

export const translateValidations = (data, context) => {

    translateList(data.errors, null, context)

    if (data.fieldErrors) {
        for (let field in data.fieldErrors)
        {
            translateList(data.fieldErrors[field], field, context)
        }
    }
}

function translateList(list, field, context)
{
    let translated

    if (list) {
        for (let i = 0; i < list.length; i++) {

            //first, try in context
            if (context) {

                if (field) {
                    translated = tryTranslate( "validation.context." + context + ".fieldScope." + field, list, i)
    
                    if (translated) 
                        continue
                }

                translated = tryTranslate("validation.context." + context, list, i)

                if (translated) 
                    continue
            }


            if (field) {
                
                translated = tryTranslate("validation.fieldScope." + field, list, i)

                if (translated) 
                    continue
            }

            tryTranslate("validation", list, i)
        }
    }
}

function tryTranslate(strId, list, i)
{
    let value = list[i]
    let isValeuString = isString(value)

    let key = strId + "." + ( isValeuString ? value : value.key)
    let message = vueInstance.$t(key, (isValeuString ? null : formatVariables(value.variables)) )

    if (message != key) {
        list[i] = message
        return true
    }
}

function formatVariables(variables)
{
    if (!variables)
        return variables
    
    for (let key in variables)
    {
        let value = variables[key]

        if (Array.isArray(value))
        {
            value = value.map(e => '"' + e + '"').join(", ")
        }

        variables[key] = value
    }

    return variables
}